document.addEventListener("DOMContentLoaded", () => {

    document.addEventListener("click", () => {
        setTimeout(() => {
            const prev_selected_variant = current_variant_id;
            checkVariantAndPriceUpdate();
            if(prev_selected_variant == selected_variant?.id) return;
            calculateProductArea();
        }, 10);
    });

    // Variant dependent variables for correct price calculation
    let current_variant_id = variants[0].id;
    let selected_variant;
    let base_product_price;
    let url_params = new URLSearchParams(window.location.search);

    // Function that checks whether another variant has been selected
    const checkVariantAndPriceUpdate = () => {
        url_params = new URLSearchParams(window.location.search);
        // Get current variant object from variant id in the URL parameter
        if(url_params.get("variant")){
            current_variant_id = url_params.get("variant");
        }
        selected_variant = variants.filter(variant => variant.id == current_variant_id)[0];
        base_product_price = current_variant_id ? selected_variant.price / 100 : document.querySelector(".custom-discount__inputs").getAttribute("data-base-price").replace(/\./g, '').replace(',', '.');
        console.log(base_product_price);
    }
    
    checkVariantAndPriceUpdate();

    // Inputs
    const length_input = document.querySelector(".custom-discount__input--length");
    const width_input = document.querySelector(".custom-discount__input--width");
    let inputs_enabled = true;
    // Get button and clone it to remove events
    const discount_submit_btn = document.querySelector("#AddToCart");
    const discount_submit_overlay = document.createElement("div");
    discount_submit_overlay.classList.add("custom-discount__button-overlay");
    discount_submit_btn.append(discount_submit_overlay);

    // Debug
    const debug_field = document.querySelector(".custom-discount__debug");
    let debug = false;
    // Product data
    const product_id = document.querySelector(".custom-discount__inputs").getAttribute("data-product-id");
    // PDP relevant nodes
    const price_node = document.querySelector("span#ProductPrice");

    // Currency formater
    const EURNumFormat = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
    });    

    // Function that applies discount
    const applyCustomDiscount = (area_in_m2) => {
        // checkVariantAndPriceUpdate();
        let discountedPrice;
        if(area_in_m2 >=0 && area_in_m2 <= 4.99) discountedPrice = base_product_price * area_in_m2; // no discount
        else if(area_in_m2 >= 5 && area_in_m2 <= 9.99) discountedPrice = base_product_price * area_in_m2 * 0.94; // 6% discount
        else if(area_in_m2 >= 10 && area_in_m2 <= 19.99) discountedPrice = base_product_price * area_in_m2 * 0.885; // 11.5% discount
        else if(area_in_m2 >= 20 && area_in_m2 <= 49.99) discountedPrice = base_product_price * area_in_m2 * 0.828; // 17.2% discount
        else if(area_in_m2 >= 50 && area_in_m2 <= 99.99) discountedPrice = base_product_price * area_in_m2 * 0.7708; // 22.92% discount
        else if(area_in_m2 >= 100) discountedPrice = base_product_price * area_in_m2 * 0.7136; // 28.64% discount

        if(discountedPrice < base_product_price) discountedPrice = base_product_price;

        return {
            discountedPrice: EURNumFormat.format(Math.round(discountedPrice * 100) / 100).split(/\s+/).reverse().join(""), 
            realPrice : EURNumFormat.format(base_product_price * area_in_m2 < base_product_price ? base_product_price : base_product_price * area_in_m2).split(/\s+/).reverse().join("")
        };
    }

    // Function to calculate product area
    const calculateProductArea = () => {
        console.log("calculating product area");
        
        // Calculate product area
        product_area = Math.round(((length_input.value / 1000) * (width_input.value / 1000)) * 100) / 100; // rounding to two decimal places
        const {discountedPrice, realPrice} = applyCustomDiscount(product_area); // get price with discount and without
        price_node.innerHTML = `${discountedPrice}`; // display new price with discount on the frontend
        // Send data to debug node
        debug ? debug_field.innerHTML = `Area: ${product_area} in square meters<br>Price with discount: ${discountedPrice}<br>Real price: ${realPrice}` : null;
    }

    // Function that Disables/Enables inputs
    const toggleInputs = () => {
        if(inputs_enabled){
            length_input.setAttribute("disabled", "");
            width_input.setAttribute("disabled", "");
            discount_submit_btn.setAttribute("disabled", "")
            inputs_enabled = false;
        } else {
            length_input.removeAttribute("disabled");
            width_input.removeAttribute("disabled");
            discount_submit_btn.removeAttribute("disabled");
            inputs_enabled = true;
        }
    }    

    // Calculate initial product area
    let product_area = 1;
    calculateProductArea();

    // Live price update
    length_input.addEventListener("input", calculateProductArea);
    width_input.addEventListener("input", calculateProductArea);

    
    // Form submission
    discount_submit_overlay.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Disable inputs
        toggleInputs();
        // ATC Button update
        discount_submit_btn.classList.add('loading');
        discount_submit_btn.classList.add('add-item');

        // Collect product area data
        const length = length_input.value;
        const width = width_input.value;

        // Make requeest to the api
        const request = await fetch("/apps/printmarket-discount", {
            method: "POST",
            body: JSON.stringify({
                dimensions: {length, width},
                product_id,
                current_variant_id
            })
        })

        const response = await request.json();

        console.log(response);
        

        // Replace the variant
        const product_variant_id = response.duplicated_product_variant_id.split("gid://shopify/ProductVariant/")[1];
        const variant_selector = document.querySelector('select[name=id]') ? document.querySelector('select[name=id]') : document.querySelector('input[name=id]');
        variant_selector.insertAdjacentHTML('afterend', `<input value="${product_variant_id}" type="hidden" name="id"><input type="hidden" name="properties[length]" value="${response.dimensions.length} mm"><input type="hidden" name="properties[width]" value="${response.dimensions.width} mm">`);
        variant_selector.remove();

        // Add to cart
        Shopify.addItemFromFormStart('AddToCartForm');
        // ATC Button update
        discount_submit_btn.classList.remove('loading');
        discount_submit_btn.classList.remove('add-item');
        // Display drawer
        document.querySelector('#ltn__utilize-cart-menu').classList.add('ltn__utilize-open');
        document.querySelector('body').classList.add('ltn__utilize-open');
        $('.ltn__utilize-overlay').fadeIn();

        // Enable inputs
        toggleInputs();
        
    });

});